'use strict';

var dialogsReducer = function dialogsReducer(state, action) {
	if (!state) {
		state = {
			isLoadingModalShowing: false,
			flashMessages: []
		};
	}

	switch (action.type) {
		case 'SHOW_LOADING_MODAL':
			return Object.assign({}, state, {
				isLoadingModalShowing: true
			});

		case 'HIDE_LOADING_MODAL':
			return Object.assign({}, state, {
				isLoadingModalShowing: false
			});

		case 'FLASH_INFO':
			return Object.assign({}, state, {
				flashMessages: state.flashMessages.concat([{
					type: 'info',
					message: action.message
				}])
			});

		case 'FLASH_ERROR':
			return Object.assign({}, state, {
				flashMessages: state.flashMessages.concat([{
					type: 'error',
					message: action.message
				}])
			});

		case 'FLASH_SUCCESS':
			return Object.assign({}, state, {
				flashMessages: state.flashMessages.concat([{
					type: 'success',
					message: action.message
				}])
			});

		default:
			return state;
	}
};

module.exports = dialogsReducer;


//////////////////
// WEBPACK FOOTER
// ./client/reducers/dialogsReducer.js
// module id = 131
// module chunks = 5